"use strict";
/* eslint-disable camelcase */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
const changePasswordQuery_1 = __importDefault(require("./graphql/changePasswordQuery"));
class Profile {
    constructor(client, logger) {
        this.requestPasswordChange = async (email) => {
            const { data: { resetPassword }, } = await this.client.post("/graphql", {
                operationName: "ResetPassword",
                query: "query ResetPassword($email: String!) { resetPassword(email: $email) }",
                variables: { email },
            }, false);
            if (!resetPassword) {
                throw new exception_1.DomainException("Reset password failed, server respond with false");
            }
        };
        this.changePassword = async (currentPassword, newPassword, newPasswordRepeated) => {
            const response = await this.client.post("/graphql", {
                operationName: "changePassword",
                query: changePasswordQuery_1.default,
                variables: {
                    newPassword,
                    newPasswordRepeated,
                    currentPassword,
                },
            });
            if (!response.data.changePassword.success) {
                this.logger.log(response.data.changePassword.messages.join(","));
                throw new exception_1.DomainException("Failed to change password!");
            }
        };
        this.logger = logger;
        this.client = client;
    }
}
exports.default = Profile;
//# sourceMappingURL=Profile.js.map